import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { MetricDelta } from '@/experiences/sales-portal/domain/accounts/screens/account-detail/components/metric-delta';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface MetricDataBoxProps {
  changePercentage: number | null;
  label: string;
  value: string;
}

export const MetricDataBox: React.FC<MetricDataBoxProps> = ({
  changePercentage,
  label,
  value,
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Typography
          color={theme.sk.color.text.secondary}
          variant="paragraph-sm"
        >
          {label}
        </Typography>
        <View style={styles.valueColumn}>
          <Typography variant="heading-sm">{value}</Typography>
          <MetricDelta changePercentage={changePercentage} />
        </View>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderColor: theme.sk.color.border.primary,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    flex: 1,
    justifyContent: 'space-between',
    minHeight: 64,
    overflow: 'hidden',
    paddingHorizontal: theme.sk.spacing.spaceMedium,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  content: {
    gap: theme.sk.spacing.spaceXsmall,
  },
  valueColumn: {
    gap: theme.sk.spacing.spaceXsmall,
  },
}));
